import {
    AppBar,
    Box,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Switch,
    Tab,
    TextField,
    Typography,
} from '@material-ui/core/';
import {TabContext, TabList, TabPanel} from '@material-ui/lab';
import React, {useEffect, useState} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useWidth from 'hooks/useWidth';

const headingText = 'Heading';
const bodyText =
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore';
const headers = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(variant => {
    return {variant: variant, text: `${variant}. ${headingText}`};
});
const boddies = ['body1', 'body2', 'subtitle1', 'subtitle2'].map(variant => {
    return {variant: variant, text: `${variant}. ${bodyText}`};
});
const others = ['button', 'caption', 'overline'].map(variant => {
    return {variant: variant, text: `${variant} text`};
});
const typoSet = [...headers, ...boddies, ...others];

const PrintScreenWidth = () => {
    const width = useWidth();
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <React.Fragment>
            <Typography variant='body1' paragraph>
                Your current media rating is {width}
            </Typography>
            <Typography variant='body1' paragraph>
                Your current viewport dimensions are width:{windowSize.width}px,
                height:{windowSize.height}px
            </Typography>
        </React.Fragment>
    );
};

const TypographyOverview = () => {
    return (
        <Grid container direction='column' spacing={2}>
            {typoSet.map(variant => (
                <Grid item>
                    <Typography variant={variant.variant}>
                        {variant.text}
                    </Typography>
                </Grid>
            ))}
        </Grid>
    );
};

const isObject = obj =>
    Object.prototype.toString.call(obj) === '[object Object]';

const ExpandInsides = props => {
    const dict = props.dict;
    return (
        <React.Fragment>
            {Object.keys(dict).map(attribute => {
                const value = dict[attribute];
                return (
                    <Typography variant='body2'>
                        <Box fontWeight='bold' component='span'>
                            {attribute}:{' '}
                        </Box>
                        {!isObject(value) && value}
                        {isObject(value) && (
                            <Box paddingLeft='1em'>
                                <ExpandInsides dict={value} />
                            </Box>
                        )}
                    </Typography>
                );
            })}
        </React.Fragment>
    );
};

const TypographyDetailed = () => {
    const theme = useTheme();
    const classes = useStyles();
    return (
        <Grid container direction='column' spacing={3}>
            {typoSet.map(variant => (
                <Grid item>
                    <Paper className={classes.paper}>
                        <Typography variant={variant.variant}>
                            {variant.variant} Sample
                        </Typography>
                        <ExpandInsides
                            dict={theme.typography[variant.variant]}
                        />
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

const useStyles = makeStyles(theme => ({
    paper: {
        padding: '1em',
    },
}));

const TypographyExplorer = () => {
    const [text, setText] = useState('sample');
    const [variant, setVariant] = useState('body1');
    const [fontSize, setFontSize] = useState('1');
    const [fontSizeType, setFontSizeType] = useState('em');
    const [customButtons, setCustomButtons] = useState({
        bold: false,
        italic: false,
    });
    const handleTextChange = event => {
        setText(event.target.value);
    };
    const handleVariantChange = event => {
        setVariant(event.target.value);
    };
    const handleFontSizeChange = event => {
        setFontSize(event.target.value);
    };
    const handleFontSizeTypeChange = event => {
        setFontSizeType(event.target.value);
    };
    const fontSizeAndType = () => {
        return `${fontSize}${fontSizeType}`;
    };
    const handleButtonChange = event => {
        setCustomButtons({
            ...customButtons,
            [event.target.name]: event.target.checked,
        });
    };
    const classes = useStyles();
    return (
        <Grid container direction='column' spacing={3}>
            <Grid item>
                <Paper className={classes.paper}>
                    <Grid container direction='column' spacing={2}>
                        <Grid item>What text do you want to try out?</Grid>
                        <Grid item>
                            <TextField
                                label='Write something!'
                                onChange={handleTextChange}
                                multiline
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item>
                <Paper className={classes.paper}>
                    <Grid container direction='column' spacing={2}>
                        <Grid item>Typography</Grid>
                        <Grid item>
                            <Select
                                value={variant}
                                onChange={handleVariantChange}
                            >
                                {typoSet.map(option => (
                                    <MenuItem value={option.variant}>
                                        {option.variant}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item>
                            <Typography variant={variant}>{text}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item>
                <Paper className={classes.paper}>
                    <Grid container direction='column' spacing={2}>
                        <Grid item>Custom</Grid>
                        <Grid item container direction='row' spacing={2}>
                            <Grid item>
                                <TextField
                                    id='font-size'
                                    label='Font Size'
                                    type='number'
                                    value={fontSize}
                                    onChange={handleFontSizeChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <InputLabel shrink>Font Size Unit</InputLabel>
                                <Select
                                    value={fontSizeType}
                                    onChange={handleFontSizeTypeChange}
                                >
                                    {['em', 'rem', 'px'].map(option => (
                                        <MenuItem value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid item>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={customButtons.bold}
                                                onChange={handleButtonChange}
                                                name='bold'
                                            />
                                        }
                                        label='Bold'
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={customButtons.italic}
                                                onChange={handleButtonChange}
                                                name='italic'
                                            />
                                        }
                                        label='Italic'
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Typography>
                                <Box
                                    fontSize={fontSizeAndType()}
                                    fontWeight={customButtons.bold && 'bold'}
                                    fontStyle={customButtons.italic && 'italic'}
                                >
                                    {text}
                                </Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

const TypographyWidget = () => {
    const [section, setSection] = useState('2');
    const handleSectionChange = (event, newValue) => {
        setSection(newValue);
    };

    return (
        <TabContext value={section}>
            <AppBar position='static' color='default'>
                <TabList
                    onChange={handleSectionChange}
                    indicatorColor='primary'
                    textColor='primary'
                    variant='fullWidth'
                    aria-label='typography tabs'
                    centered
                >
                    <Tab label='Meta' value='1' />
                    <Tab label='Overview' value='2' />
                    <Tab label='Detailed' value='3' />
                    <Tab label='Explore' value='4' />
                </TabList>
            </AppBar>
            <TabPanel value='1'>
                <PrintScreenWidth />
            </TabPanel>
            <TabPanel value='2'>
                <TypographyOverview />
            </TabPanel>
            <TabPanel value='3'>
                <TypographyDetailed />
            </TabPanel>
            <TabPanel value='4'>
                <TypographyExplorer />
            </TabPanel>
        </TabContext>
    );
};

export default TypographyWidget;
